<template>
    <v-form
        v-model="valid"
        @submit.prevent="submit"
    >
        <p class="title">Pengaturan akun</p>

        <v-text-field
            v-model="name"
            label="Nama lengkap"
            :rules="rules.name"
            autofocus
        ></v-text-field>

        <v-text-field
            v-model="username"
            label="Username"
            :rules="rules.username"
            ref="username"
            @change="checkUsernameAvailability"
            :loading="$store.get('loader/loading', 'usernameLookup')"
            :success-messages="usernameSuccessMessage"
            :error-messages="usernameErrorMessage"
        ></v-text-field>

        <v-text-field
            v-model="email"
            label="E-mail"
            :rules="rules.email"
            ref="email"
            @change="checkEmailAvailability"
            :loading="$store.get('loader/loading', 'emailLookup')"
            :success-messages="emailSuccessMessage"
            :error-messages="emailErrorMessage"
        ></v-text-field>

        <v-autocomplete
            v-model="university"
            label="Tipe Ujian"
            :items="universities"
            :rules="rules.university"
        ></v-autocomplete>

        <v-btn
            type="submit"
            large
            :disabled="!valid"
            :loading="$store.get('loader/loading', 'saving')"
            color="primary"
        >
            Simpan
        </v-btn>
    </v-form>
</template>

<script>
import rules from '@/validations/SignupTryoutData'

export default {
    data() {
        return {
            rules,
            valid: null,
            universities: rules.universityLists,
            name: null,
            username: null,
            email: null,
            university: null,
            usernameSuccessMessage: '',
            usernameErrorMessage: '',
            emailSuccessMessage: '',
            emailErrorMessage: '',
        }
    },

    methods: {
        checkUsernameAvailability() {
            this.usernameSuccessMessage = ''
            this.usernameErrorMessage = ''

            if (this.$refs.username.valid) {
                this.$api
                    .get('auth/isUsernameAvailable', {
                        params: {
                            username: this.username,
                        },
                        loader: 'usernameLookup',
                    })
                    .then((response) => {
                        if (response.data.available) {
                            this.usernameSuccessMessage = 'Username tersedia'
                        } else {
                            this.usernameErrorMessage =
                                'Username sudah dipakai, gunakan username lain'
                        }
                    })
            }
        },

        checkEmailAvailability() {
            this.emailSuccessMessage = ''
            this.emailErrorMessage = ''

            if (this.$refs.email.valid) {
                this.$api
                    .get('auth/isEmailAvailable', {
                        params: {
                            email: this.email,
                        },
                        loader: 'emailLookup',
                    })
                    .then((response) => {
                        if (response.data.available) {
                            this.emailSuccessMessage = 'E-mail tersedia'
                        } else {
                            this.emailErrorMessage =
                                'E-mail sudah dipakai, gunakan e-mail lain'
                        }
                    })
            }
        },

        submit() {
            const data = {
                name: this.name,
                username: this.username,
                email: this.email,
                university: this.university,
            }

            this.$api.put('auth', data, { loader: 'saving' }).then(() => {
                this.$api.get('auth', { loader: 'saving' }).then((response) => {
                    this.$store.dispatch('auth/setDataFromAuth', response.data)

                    this.$store.dispatch(
                        'flash/info',
                        'Informasi akun telah diubah'
                    )
                })
            })
        },
    },

    created() {
        const auth = this.$store.get('auth/*')
        this.name = auth.name
        this.username = auth.username
        this.email = auth.email
        this.university = auth.university
    },
}
</script>
